import { render, staticRenderFns } from "./Compatibility.vue?vue&type=template&id=5c6fa990&scoped=true"
import script from "./Compatibility.vue?vue&type=script&lang=ts"
export * from "./Compatibility.vue?vue&type=script&lang=ts"
import style0 from "./Compatibility.vue?vue&type=style&index=0&id=5c6fa990&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6fa990",
  null
  
)

export default component.exports